// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#282c34","secondaryColor":"#61dafb","quote":"Quote_quote__nJKvO","quoteIcon":"Quote_quoteIcon__1tPJp","quoteBox":"Quote_quoteBox__1hB6I"};